(() => {
  const initVideoWrapper = (wrapper) => {
    if (wrapper.dataset.videoInitialised) return;
    wrapper.dataset.videoInitialised = 'true';

    const video = wrapper.querySelector('video');
    const fallback = wrapper.querySelector('.banner-video-fallback');
    const btn = wrapper.querySelector('.banner-video-play-pause');

    if (!video) return;
    const desktopSrc =
      wrapper.dataset.desktopVideoSrc ||
      (video.querySelector('source') && video.querySelector('source').getAttribute('src')) ||
      null;
    const mobileSrc = wrapper.dataset.mobileVideoSrc || null;

    const autoplay = wrapper.dataset.autoplay === 'true';

    const setVideoSource = () => {
      if (!desktopSrc) return;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const chosen = isMobile && mobileSrc ? mobileSrc : desktopSrc;
      const srcEl = video.querySelector('source');
      if (srcEl && srcEl.getAttribute('src') !== chosen) {
        const wasPlaying = !video.paused && !video.ended;
        srcEl.setAttribute('src', chosen);
        try {
          video.load();
          if (wasPlaying) video.play();
          else if (autoplay) {
            // Attempt to start playback when autoplay is enabled
            video.play().catch(() => {});
          }
          // eslint-disable-next-line no-unused-vars
        } catch (e) {
          // ignore load/play errors
        }
      }
    };

    // initialize and listen for viewport changes
    setVideoSource();
    try {
      const mq = window.matchMedia('(max-width: 749px)');
      if (mq.addEventListener) mq.addEventListener('change', setVideoSource);
      else if (mq.addListener) mq.addListener(setVideoSource);
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      // ignore matchMedia errors
    }

    let fallbackTimer = null;

    const applyShowFallback = () => {
      try {
        video.pause();
        // eslint-disable-next-line no-unused-vars
      } catch (e) {
        // ignore
      }
      video.style.display = 'none';
      if (fallback) {
        fallback.style.display = 'block';
        fallback.style.zIndex = '1';
      }
      if (btn) btn.style.display = 'none';
      const muteBtnLocal = wrapper.querySelector('.banner-video-mute-unmute');
      if (muteBtnLocal) muteBtnLocal.style.display = 'none';
    };

    const scheduleShowFallback = (immediate = false) => {
      const hasError = !!video.error;
      const noData = video.readyState === 0; // HAVE_NOTHING
      if (!hasError && !noData && !immediate) return;
      if (hasError || immediate) {
        if (fallbackTimer) {
          clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }
        applyShowFallback();
        return;
      }
      if (fallbackTimer) clearTimeout(fallbackTimer);
      fallbackTimer = setTimeout(() => {
        fallbackTimer = null;
        applyShowFallback();
      }, 300);
    };

    const hideFallback = () => {
      if (fallbackTimer) {
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
      }
      if (fallback) {
        fallback.style.display = 'none';
        fallback.style.zIndex = '';
      }
      video.style.display = '';
      if (btn) btn.style.display = 'flex';
      const muteBtnLocal = wrapper.querySelector('.banner-video-mute-unmute');
      if (muteBtnLocal) muteBtnLocal.style.display = 'flex';
    };

    ['error', 'abort', 'emptied'].forEach((evt) => {
      video.addEventListener(evt, () => scheduleShowFallback(true));
    });
    // Only show placeholder for stalled if the video truly has no data or an error.
    video.addEventListener('stalled', () => scheduleShowFallback(false));

    video.addEventListener('loadeddata', () => {
      hideFallback();
      if (autoplay) {
        // Some browsers require a programmatic play after load
        try {
          video.play().catch(() => {});
          // eslint-disable-next-line no-unused-vars
        } catch (e) {
          // ignore
        }
      }
    });

    // Ensure the fallback is hidden once playback starts
    video.addEventListener('playing', hideFallback);

    if (!btn) return;

    const iconPlay = btn.querySelector('.icon-play');
    const iconPause = btn.querySelector('.icon-pause');

    const syncIcons = () => {
      const paused = video.paused;
      if (iconPlay) iconPlay.style.display = paused ? '' : 'none';
      if (iconPause) iconPause.style.display = paused ? 'none' : '';
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      btn.dataset.linkText = paused ? 'videoPlay' : 'videoPause';
    };

    btn.addEventListener('click', (e) => {
      e.stopPropagation(); // prevent parent banner link from firing
      video.paused ? video.play() : video.pause();
    });

    video.addEventListener('play', syncIcons);
    video.addEventListener('pause', syncIcons);
    syncIcons();
    const muteBtn = wrapper.querySelector('.banner-video-mute-unmute');

    if (muteBtn) {
      muteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        muteBtn.querySelector('.icon-unmute').style.display = video.muted ? 'none' : '';
        muteBtn.querySelector('.icon-mute').style.display = video.muted ? '' : 'none';
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });

      // Sync icon with initial muted state
      muteBtn.querySelector('.icon-unmute').style.display = video.muted ? 'none' : '';
      muteBtn.querySelector('.icon-mute').style.display = video.muted ? '' : 'none';
    }
  };

  const init = () => {
    document.querySelectorAll('.banner-video-wrapper').forEach(initVideoWrapper);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
